import * as S from './styles.ts';

export interface IReviewCard {
  author: string;
  review: string;
}

const ReviewCard = ({ author, review }: IReviewCard) => {
  return (
    <S.CustomerReviewCard>
      <p>{author}</p>
      <S.CustomerRating></S.CustomerRating>
      <S.CustomerReview>{review}</S.CustomerReview>
    </S.CustomerReviewCard>
  );
};

export default ReviewCard;
